import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { useElementsContext } from "../elementsProvider";
import { Container } from "../Container";
function ImageWrapper({ href, children }) {
    if (href !== "") {
        return (_jsx(Link, Object.assign({ target: "_blank", href: href }, { children: children }), void 0));
    }
    return children;
}
export function RTCImage2Gallery({ image1src, image1url, image2src, image2url, skin, }) {
    const { isMobile } = useElementsContext();
    const images1 = JSON.parse(image1src);
    const images2 = JSON.parse(image2src);
    return (_jsx(ContainerStyled, { children: _jsxs(MetaContent, Object.assign({ skin: skin, isDesktop: !isMobile }, { children: [_jsx(ImageArticle, { children: _jsx(ImageWrapper, Object.assign({ href: image1url, "data-testid": "2gallery-image-1" }, { children: _jsx(Images, { src: isMobile
                                ? images1.medium
                                : skin === "3"
                                    ? images1.medium
                                    : images1.large, alt: "Imagen 1" }, void 0) }), void 0) }, void 0),
                _jsx(ImageArticle, { children: _jsx(ImageWrapper, Object.assign({ href: image2url, "data-testid": "2gallery-image-2" }, { children: _jsx(Images, { src: isMobile
                                ? images2.medium
                                : skin === "2"
                                    ? images2.medium
                                    : images2.large, alt: "Imagen 2" }, void 0) }), void 0) }, void 0)] }), void 0) }, void 0));
}
const ContainerStyled = styled(Container)({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
});
const MetaContent = styled.div(({ skin, isDesktop }) => {
    let gridGap;
    let gridTemplateColumns;
    let gridTemplateRows;
    let gridAutoRows;
    let width;
    switch (skin) {
        case "2":
            gridGap = "0.8rem";
            gridTemplateColumns = "62rem 30rem";
            gridTemplateRows = "30rem 14.8rem";
            gridAutoRows = "30rem";
            width = "30rem";
            break;
        case "3":
            gridGap = "0.8rem";
            gridTemplateColumns = "30rem 62rem";
            gridTemplateRows = "14.8rem 30rem";
            gridAutoRows = "30rem";
            width = "30rem";
            break;
        default:
            // skin 1
            gridGap = "2rem";
            gridTemplateColumns = "46rem 46rem";
            gridTemplateRows = "28rem 28rem";
            gridAutoRows = "46rem";
            width = "28rem";
            break;
    }
    return Object.assign({ alignItems: "center", display: "grid", gridGap: gridGap, gridTemplateRows: gridTemplateRows, width: width }, (isDesktop
        ? {
            gridGap: "2rem",
            gridTemplateColumns: gridTemplateColumns,
            gridTemplateRows: gridAutoRows,
            gridAutoRows: gridAutoRows,
            width: "94rem",
        }
        : {}));
});
const Images = styled.img(() => ({
    height: "100%",
    objectFit: "cover",
    width: "100%",
}));
const Link = styled.a(() => ({
    height: "100%",
}));
const ImageArticle = styled.article({
    height: "100%",
});
//# sourceMappingURL=RTCImage2Gallery.js.map